export enum Permission {
  DevPortalAdmin = 'dev_portal_admin.view',
  WebhookConfigurationDevPortal = 'webhook_configuration_dev_portal.view',
}
